<template>
    <div class="flex-column">
        <div class="settings-template flex flex-column ov-reset self-center wp-10">
            <Heading
                :labelTitle="currentMenuItemLabel"
                :labelTooltip="$t.__('settings.SettingsTemplate.back_settings')"
                :showBackButton="true"
                @go-back="handleGoBack"
            />
            <PageLayoutSettings>
                <template #sidebar>
                    <SettingsMenu
                        v-if="Object.keys(menuItems).length > 0"
                        ref="settingsMenu"
                        :customMenu="menuItems"
                    />
                </template>
                <template #content>
                    <router-view class="settings-template__content"></router-view>
                </template>
            </PageLayoutSettings>
        </div>
    </div>
</template>

<script>
import Heading from 'vcomponents/common/Heading/Heading.vue';
import PageLayoutSettings from 'vcomponents/common/layout/pages/PageLayoutSettings.vue';
import SettingsMenu from 'vcomponents/settings/SettingsMenu.vue';

export default {
    components: {
        Heading,
        SettingsMenu,
        PageLayoutSettings,
    },
    props: {
        menuItems: {
            type: Object,
            default: () => ({}),
        },
        backUrl: {
            type: String,
            required: false,
            default: '/settings',
        },
    },
    data() {
        return {
            currentMenuItem: null,
        };
    },
    computed: {
        currentMenuItemLabel() {
            return this.currentMenuItem ? this.currentMenuItem.label : '';
        },
    },
    mounted() {
        const menu = this.$refs.settingsMenu;
        if (menu) {
            this.currentMenuItem = menu.currentMenuItem;
        }
    },
    methods: {
        handleGoBack() {
            this.$router.push(this.backUrl);
        },
    },
};
</script>

<style lang="scss" scoped>
.settings-template {
    margin-bottom: var(--spacing-4);
}
</style>
